import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule as ReduxStoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';
import { OrderStateModule } from './order/state.module';
import { ProblemStateModule } from './problem/state.module';
import { ProblemForUserStateModule } from './problem-user/state.module';
import { UserStateModule } from './user/state.module';
import { SearchServiceStateModule } from './self-diagnostic/search-service/state.module';
import { SelfDiagnosisStateModule } from './self-diagnostic/self-diagnosis/state.module';
import { SelfDiagnosticStepStateModule } from './self-diagnostic/self-diagnostic-step/state.module';
import { UrgencyStateModule } from './urgency/state.module';
import { ServiceCatalogStateModule } from './self-diagnostic/service-catalog/state.module';
import { ServiceTypeStateModule } from './service-type/state.module';
import { NotificationTemplateStateModule } from './notification-template/state.module';
import { TopServiceStateModule } from './self-diagnostic/top-service/state.module';

@NgModule({
  imports: [
    CommonModule,
    OrderStateModule,
    ProblemStateModule,
    ProblemForUserStateModule,
    UserStateModule,
    SearchServiceStateModule,
    SelfDiagnosisStateModule,
    SelfDiagnosticStepStateModule,
    UrgencyStateModule,
    ServiceCatalogStateModule,
    ServiceTypeStateModule,
    NotificationTemplateStateModule,
    TopServiceStateModule,
    ReduxStoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    !environment.production ? StoreDevtoolsModule.instrument({ logOnly: environment.production, connectInZone: true }) : [],
  ],
  exports: [
    OrderStateModule,
    ProblemStateModule,
    ProblemForUserStateModule,
    UserStateModule,
    SearchServiceStateModule,
    SelfDiagnosisStateModule,
    SelfDiagnosticStepStateModule,
    UrgencyStateModule,
    ServiceCatalogStateModule,
    ServiceTypeStateModule,
    NotificationTemplateStateModule,
    TopServiceStateModule,
  ],
  providers: [],
})
export class StoreModule {}
